import { getTenantNameActionHandler } from "../store/actions/actionHandlers/commonActionHandler";

const getTenantName = (dispatch, location) => {
  return (
    dispatch(getTenantNameActionHandler()) ||
    localStorage.getItem("tenantName") ||
    location?.pathname?.split("/")[1]
  );
};

export default getTenantName;
